import { VerificationTemplate } from 'dashboard/models/verification-template';
import { VerificationTemplateVersion } from 'dashboard/models/verification-template-version';
import Action from 'lib/interfaces/Action';

export type VerificationTemplateActions =
  | Action<VerificationTemplateActionType.ClearVerificationTemplate>
  | Action<VerificationTemplateActionType.SetVerificationTemplate, SetVerificationTemplatePayload>
  | Action<
      VerificationTemplateActionType.SetVerificationTemplateVersion,
      SetVerificationTemplateVersionPayload
    >;

export enum VerificationTemplateActionType {
  ClearVerificationTemplate = 'verificationTemplate/CLEAR_VERIFICATION_TEMPLATE',
  SetVerificationTemplate = 'verificationTemplate/SET_VERIFICATION_TEMPLATE',
  SetVerificationTemplateVersion = 'verificationTemplate/SET_VERIFICATION_TEMPLATE_VERSION',
}

export function clearVerificationTemplate(): Action<VerificationTemplateActionType.ClearVerificationTemplate> {
  return { type: VerificationTemplateActionType.ClearVerificationTemplate };
}

interface SetVerificationTemplatePayload {
  verificationTemplate: VerificationTemplate;
}

export function setVerificationTemplate(
  verificationTemplate: VerificationTemplate,
): Action<VerificationTemplateActionType.SetVerificationTemplate, SetVerificationTemplatePayload> {
  return {
    payload: {
      verificationTemplate,
    },
    type: VerificationTemplateActionType.SetVerificationTemplate,
  };
}

interface SetVerificationTemplateVersionPayload {
  verificationTemplateVersion: VerificationTemplateVersion;
}

export function setVerificationTemplateVersion(
  verificationTemplateVersion: VerificationTemplateVersion,
): Action<
  VerificationTemplateActionType.SetVerificationTemplateVersion,
  SetVerificationTemplateVersionPayload
> {
  return {
    payload: {
      verificationTemplateVersion,
    },
    type: VerificationTemplateActionType.SetVerificationTemplateVersion,
  };
}
